import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from 'src/app/services/auth.service';
import {CertificateService} from 'src/app/services/certificate.service';
import {ContextService} from 'src/app/services/context.service';
import {Subscription} from 'rxjs';
import {MatTableDataSource} from '@angular/material/table';
import {EventService} from 'src/app/services/event.service';

@Component({
  selector: 'app-congresses',
  templateUrl: './congresses.component.html',
  styleUrls: [ './congresses.component.scss' ]
})
export class CongressesComponent implements OnInit {

  private sub: Subscription;

  public displayedColumns: string[] = [ 'icon', 'name', 'more', 'edit' ];
  public selectedContext: any;

  constructor (
    public _certificateService: CertificateService,
    public _authService: AuthService,
    public _router: Router,
    public _contextService: ContextService,
    public _eventService: EventService
  ) {

  }

  ngOnInit () {
    this._eventService.eventDataSource = null;
    this.loadContexts(true);
  }

  async loadContexts (isCongress: boolean) {
    const array = await this._contextService.loadContexts(isCongress)
    this._eventService.eventDataSource = new MatTableDataSource(array);
  }

  compareContexts (a, b) {

    const pa = String(a.id)
    const pb = String(b.id)

    if (pa < pb) return 1;
    if (pb < pa) return -1;
    return 0;

  }

  gotoCongressEvents (element) {
    // console.log("gotoCongressEvents: " + element.id)
    this._router.navigate([ 'congress-events/' + element.id ]);
  }

  gotoLettersSpeakers (element) {
    this._router.navigate([ '/letters-speakers/true/' + element.id ]);
  }

  gotoLettersSubscriptions (element) {
    this._router.navigate([ '/letters-subscriptions/true/' + element.id ]);
  }

  gotoCertificatesSpeakers (element) {
    if (element.id == "51º Congresso" ||element.id == "50º Congresso" || element.id == "49º Congresso" || element.id == "48º Congresso" || element.id == "47º Congresso") {
      this._router.navigate([ '/certificates-speakers/true/' + element.id ]);
    } else {
      this._router.navigate([ '/certificates-speakers_v2/true/' + element.id ]);
    }


  }

  gotoCertificatesSubscriptions (element) {
    this._router.navigate([ '/certificates-subscriptions/true/' + element.id ]);
  }

  gotoCertificatesArchives () {
    this._router.navigate([ '/certificates-archives/true' ]);
  }

  gotoCertificates (element) {
    this._router.navigate([ '/certificates/true/' + element.id ]);
  }

  async gotoPublish (event) {
    const master: any = await this._contextService.getMasterEvent(event.id);
    console.log("master: " + JSON.stringify(master))

    if (master.key == "51Congresso" || master.key == "52Congresso" || master.key == "53Congresso") {
      const url = this._router.serializeUrl(this._router.createUrlTree([ 'event-publish/' + master.key + ":" + true ]));
      window.open(url, '_blank');
    }
  }

  async gotoSchedule (event) {
    // console.log(event)
    const master: any = await this._contextService.getMasterEvent(event.id);
    if (master.key == "52Congresso") {
      const url = 'https://sbccv.org.br/programa/' + master.key
      // const url = this._router.serializeUrl(this._router.createUrlTree([ 'programa/' + master.key ]));
      window.open(url, '_blank');
    } else if (master.key == "51Congresso") {
      const url = this._router.serializeUrl(this._router.createUrlTree([ 'programa/' + master.key ]));
      window.open(url, '_blank');
    } else if (master.key == "sbccv50") {
      const url = this._router.serializeUrl(this._router.createUrlTree([ '/50' ]));
      window.open(url, '_blank');
    } else if (master.key == "49Congresso") {
      const url = this._router.serializeUrl(this._router.createUrlTree([ '/49' ]));
      window.open(url, '_blank');
    }
  }


}
